import { clone, delay } from "./client";
import { api, USE_MOCK_API } from "./http";
import { PRODUCTS } from "./mock-data";
import type { Product } from "./types";

/** Mock wishlist store — used only while no backend is configured. */
let favorites = new Set<string>(["p2", "p5"]);

interface WishlistPayload {
  ids: string[];
  items: Product[];
}

/** GET /api/wishlist */
export async function getFavorites(): Promise<Product[]> {
  if (!USE_MOCK_API) return (await api.get<WishlistPayload>("/wishlist")).items;
  const items = PRODUCTS.filter((p) => favorites.has(p.id));
  return delay(clone(items), 200);
}

/** GET /api/wishlist (ids only) */
export async function getFavoriteIds(): Promise<string[]> {
  if (!USE_MOCK_API) return (await api.get<WishlistPayload>("/wishlist")).ids;
  return delay([...favorites], 120);
}

/** POST /api/wishlist */
export async function toggleFavorite(productId: string): Promise<string[]> {
  if (!USE_MOCK_API) {
    const current = await getFavoriteIds();
    if (current.includes(productId)) {
      return (await api.del<WishlistPayload>(`/wishlist/${encodeURIComponent(productId)}`)).ids;
    } else {
      return (await api.post<WishlistPayload>("/wishlist", { productId })).ids;
    }
  }

  const next = new Set(favorites);
  if (next.has(productId)) next.delete(productId);
  else next.add(productId);
  favorites = next;
  return delay([...favorites], 150);
}

/** DELETE /api/wishlist/:productId */
export async function removeFavorite(productId: string): Promise<string[]> {
  if (!USE_MOCK_API) {
    return (await api.del<WishlistPayload>(`/wishlist/${encodeURIComponent(productId)}`)).ids;
  }

  const next = new Set(favorites);
  next.delete(productId);
  favorites = next;
  return delay([...favorites], 150);
}
